import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/i18n";

const I18nContext = createContext(null);
const LANG_CYCLE = ["en", "ar", "fr"];
const LANG_LABEL = { en: "English", ar: "العربية", fr: "Français" };

export const I18nProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        const stored = localStorage.getItem("utal_lang");
        return LANG_CYCLE.includes(stored) ? stored : "en";
    });
    useEffect(() => {
        localStorage.setItem("utal_lang", lang);
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    }, [lang]);
    const t = (key) => translations[lang]?.[key] || translations.en[key] || key;
    // Cycle en → ar → fr → en. The nav button label shows the NEXT language.
    const toggle = () => setLang((l) => {
        const i = LANG_CYCLE.indexOf(l);
        return LANG_CYCLE[(i + 1) % LANG_CYCLE.length];
    });
    const nextLangLabel = () => {
        const i = LANG_CYCLE.indexOf(lang);
        return LANG_LABEL[LANG_CYCLE[(i + 1) % LANG_CYCLE.length]];
    };
    return (
        <I18nContext.Provider value={{ lang, t, toggle, setLang, nextLangLabel, langs: LANG_CYCLE, langLabel: LANG_LABEL }}>
            {children}
        </I18nContext.Provider>
    );
};

export const useI18n = () => useContext(I18nContext);
